import React, { createRef } from 'react';
import { Button } from 'semantic-ui-react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Modal from 'shared/components/Modal';
import CloseIcon from '@material-ui/icons/Close';
import messages, { FormattedMessage } from 'shared/messages/messages';

import {
    APP_BASE_URL,
    GET_SELFIE_URL
} from 'shared/utils/Constants';

import 'semantic-ui-css/semantic.min.css';

const styles = theme => ({
    form: {
        position: 'relative',
        zIndex: 2,
        width: '100%',
        background: '#fff',
        padding: '2rem 2rem',
        margin: '4vh auto 0',
        boxShadow: '3px 3px 20px rgba(0, 0, 0, 0.5)',
        maxWidth: '350px',
        borderRadius: '10px'
    },
    formBackdrop: {
        position: 'fixed',
        zIndex: 1,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))'
    },
    closeIcon: {
        position: 'absolute',
        top: '5px',
        right: '5px',
        color: '#949494',
        opacity: 0.5,
        cursor: 'pointer',
        '&:hover': {
            opacity: 1
        }
    },
    buttonContainer: {
        textAlign: 'center',
        margin: '1em'
    },
    statusText: {
        margin: '1em'
    },
    selfieImage: {
        width: '80%',
        margin: 'auto'
    }
})

class NewPhotosModal extends React.Component {
    constructor(props) {
        super(props);
    }

    handleViewPhotos = () => {
        const { storyId, isKiosk, onViewPhotos } = this.props;

        if (!isKiosk) {
            window.location.href = window.location.href.replace("/selfie", "");
        } else {
            if (onViewPhotos) {
                onViewPhotos();
            }
        }
    }


    render() {
        const { classes, user, storyId } = this.props;

        // let newPhotosHeader = <FormattedMessage {...messages.consumer_new_photos_header} />
        // let newPhotosText = <FormattedMessage {...messages.consumer_new_photos_text} />
        // let newPhotosButton = <FormattedMessage {...messages.consumer_new_photos_button} />

        let newPhotosHeader = "Good News!"
        let newPhotosText = "We've found some photos for you."
        let newPhotosButton = "View photos"

        return (
            <Modal
                disableScrollbar={true}
                isOpen={this.props.open}
                close={this.props.onClose.bind(this)}>
                <div className={classes.formBackdrop}></div>
                <div className={classes.form}>
                    <CloseIcon className={classes.closeIcon} onClick={this.props.onClose.bind(this)} />
                    <h3>
                        {newPhotosHeader}
                    </h3>
                    <p>
                        {newPhotosText}
                    </p>
                    <div className={classes.buttonContainer}>
                        <Button onClick={() => this.handleViewPhotos()}>
                            {newPhotosButton}
                        </Button>
                    </div>
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = state => ({
    user: state.userReducer.user
});

const NewPhotosComponent = withStyles(styles, { withTheme: true })(NewPhotosModal);
export default connect(mapStateToProps, {})(NewPhotosComponent);
